import buttonLoader from '../utilities/buttonLoader.js';

var searchPage = {};

searchPage = {

  el: {
    filters: document.querySelectorAll('.search-results__filter'),
    activeFilter: document.querySelector('.search-results__filter--active'),
    categories: document.querySelectorAll('.search-results__category'),
    searchBtn: document.querySelector('.search__button'),
    searchInput: document.querySelector('.search__input'),
    searchForm: document.querySelector('.search__form')
  },

  init: function () {
    const searchForm = this.el.searchForm
    const searchBtn = this.el.searchBtn
    const searchInput = this.el.searchInput
    const filters = this.el.filters

    if (searchBtn && searchInput) {
      if (searchForm) {
        searchForm.addEventListener('submit', () => {
          buttonLoader.start(searchBtn);
        })
      }
      searchInput.addEventListener('keyup', (e) => {
        if (e.target.value.length >= 2) {
          searchBtn.disabled = false;
        }
        else {
          searchBtn.disabled = true;
        }
      })
    }
    if (filters) {
      filters.forEach(filter => {
        filter.addEventListener('click', e => this.onFilterClick(filter))
      })
    }
  },

  onFilterClick: function(selectedFilter) {
    const filters = this.el.filters;
    const categories = this.el.categories;
    if (!selectedFilter.classList.contains('search-results__filter--active')) {

      filters.forEach(filter => {
        filter.classList.remove('search-results__filter--active');
      })

      const filterValue = selectedFilter.getAttribute('data-category');
      if (categories) {
        if (filterValue === "all") {
          categories.forEach(cat => {
            cat.classList.remove('search-results__category--hidden')
          })
        }
        else {
          categories.forEach(cat => {
            const categoryValue = cat.getAttribute("data-category");
            if (filterValue === categoryValue) {
              cat.classList.remove('search-results__category--hidden')
            }
            else {
              cat.classList.add('search-results__category--hidden')
            }
          })
        }
      }

      selectedFilter.classList.add('search-results__filter--active');

    }
  }
};

searchPage.initialize = function () {
  searchPage.init();
};

module.exports = searchPage;
